import { FC, useRef, useState } from "react";
import styled from "styled-components";
import { FormInstance } from "antd";
import {
  AppButton,
  AuthLayout,
  Form,
  FORM_FIELD_TYPES,
  IFormItems,
} from "site/ui/base";

const ButtonContainer = styled.div`
  margin-top: 0.5rem;
`;

export interface AdminLoginProps {
  onAdminLogin: (data: {email: string; password: string; isAdmin: true}) => Promise<void>
}
export const AdminLogin:FC<AdminLoginProps> = ({
  onAdminLogin
}) => {
  const formRef = useRef<FormInstance>(null);
  const [loading, setLoading] = useState(false)

  const formItems: IFormItems[] = [
    {
      fieldType: FORM_FIELD_TYPES.TEXT,
      itemProps: {
        name: "email",
        label: "Email address",
        rules: [{ required: true, message: "Please input your email!" }],
      },
      fieldProps: {
        placeholder: "esosa@example.art",
        size: "large",
      },
    },
    {
      fieldType: FORM_FIELD_TYPES.PASSWORD,
      itemProps: {
        name: "password",
        label: "Password",
        rules: [{ required: true, message: "Please input your password!" }],
      },
      fieldProps: {
        placeholder: "• • • • • • •",
        size: "large",
      },
    },
  ];

  const handleSubmit = (values: { email: string; password: string;}) => {
    setLoading(true);
    onAdminLogin({...values, isAdmin: true}).finally(() => {
      setLoading(false)
    })
  };

  const handleLogin = () => {
    formRef.current?.submit();
  };

  return (
    <AuthLayout title="Admin login">
      <Form
        formRef={formRef}
        items={formItems}
        formProps={{
          onFinish: handleSubmit,
          layout: "vertical",
        }}
      />

      <ButtonContainer>
        <AppButton loading={loading} variant="primary" fullWidth onClick={handleLogin}>
          Login
        </AppButton>
      </ButtonContainer>
    </AuthLayout>
  );
};
